import cloneDeep from 'lodash/cloneDeep';

export function createEmplacementDispositifMaterielFace(dispositif, emplacements) {
  const emplacement = cloneDeep(dispositif.emplacement);
  emplacement.selected = false;
  emplacement.open = false;
  dispositif.materiels.forEach(m => {
    m.open = false;
  });
  emplacement.dispositifs = [];
  emplacement.dispositifs.push(cloneDeep(dispositif));
  emplacements.push(emplacement);
}

export function getEmplacementDispositifMaterielAndFaceFromListeDispositif(dispositifs) {
  const emplacements = [];
  dispositifs.forEach((dispositif) => {
    dispositif.selected = false;
    dispositif.open = false;
    const emplacementExistant = emplacements.find((el) => {
      return el.id === dispositif.emplacementId;
    });

    if (!emplacementExistant) {
      createEmplacementDispositifMaterielFace(dispositif, emplacements);
    } else {
      dispositif.materiels.forEach(m => {
        m.open = false;
      });
      emplacementExistant.dispositifs.push(dispositif);
    }
  });
  return emplacements;
}
